import { render, staticRenderFns } from "./CourseDatabaseManagement.vue?vue&type=template&id=4df91baa&scoped=true&"
import script from "./CourseDatabaseManagement.vue?vue&type=script&lang=js&"
export * from "./CourseDatabaseManagement.vue?vue&type=script&lang=js&"
import style0 from "./CourseDatabaseManagement.vue?vue&type=style&index=0&id=4df91baa&lang=less&scoped=true&"
import style1 from "./CourseDatabaseManagement.vue?vue&type=style&index=1&id=4df91baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df91baa",
  null
  
)

export default component.exports